import { inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import Keycloak, { KeycloakInitOptions } from 'keycloak-js';
import { AutoRefreshTokenService } from 'keycloak-angular';

export const KEYCLOAK_INIT_OPTIONS: KeycloakInitOptions = {
  onLoad: 'login-required',
  pkceMethod: 'S256',
  // The status iframe reads the Keycloak cookie as a third-party cookie, which many modern browsers block.
  checkLoginIframe: false,
};

type AutoRefreshOptions = NonNullable<Parameters<AutoRefreshTokenService['start']>[0]>;

export function autoRefreshOptions(origin: string): AutoRefreshOptions {
  return {
    sessionTimeout: 30 * 60 * 1000,
    onInactivityTimeout: 'logout',
    logoutOptions: { redirectUri: `${origin}/` },
  };
}

// The library initializer swallows errors from init() and would bootstrap an unauthenticated app.
export async function initializeKeycloak(): Promise<void> {
  const origin = inject(DOCUMENT).location.origin;
  inject(AutoRefreshTokenService).start(autoRefreshOptions(origin));
  await inject(Keycloak).init(KEYCLOAK_INIT_OPTIONS);
}
